import { defineComponent } from 'vue';
export default defineComponent({
    name: 'RightSelect',
    emits: ['update:modelValue'],
    props: {
        label: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    setup(props, { emit }) {
        const handleClick = (val) => {
            if (props.modelValue === val) {
                return;
            }
            emit('update:modelValue', val);
        };
        return {
            handleClick,
        };
    },
});
